import React, { useEffect } from 'react';

const BlockInput = ({ block, className = '', isEditing, settingsFunnel }) => {
   

    if(block.inputs === undefined){
        block.inputs = [
            {
                id: `input-${Math.random().toString(36).substr(2, 9)}`,
                type: 'text',
                label: '',
                placeholder: 'Qual o seu nome?',
                required: true,
            },
            {
                id: `input-${Math.random().toString(36).substr(2, 9)}`,
                type: 'email',
                label: '',
                placeholder: 'Qual o seu email?',
                required: true,
            },
            {
                id: `input-${Math.random().toString(36).substr(2, 9)}`,
                type: 'phone',
                label: '',
                placeholder: 'Qual o seu whatsapp?',
                required: true,
            },
          
        ];
    }
    
    // Ensure each input has an ID if it doesn't have one
    block.inputs.forEach((input, index) => {
        if (!input.id) {
            input.id = `input-${Math.random().toString(36).substr(2, 9)}`;
        }
    });

    return (
        <div className={`flex flex-col gap-3   w-full ${className}`}>
            {block.inputs.map((input, index) => (
                <div
                    key={input.id || index}
                    id={`input-container-${input.id}`}
                    className={
                        `flex flex-col w-full   rounded-md  transition-colors duration-200 ` +
                        (input.animate ? 'border-red-500 shake ' : 'border-gray-200 ')
                    }
                >
                    {input.label && (
                        <label className="text-xs text-gray-600 mb-1" style={{color: settingsFunnel.secondaryColor, fontFamily: settingsFunnel.font }} >
                            {input.label}
                            {input.required && <span className="text-red-500 ml-1">*</span>}
                        </label>
                    )}
                    <div className={`bg-white rounded-md p-2 ${block.border ? 'border-2 border-gray-200' : ''}`}>
                    <input
                        type={input.type === 'name' ? 'text' : input.type}
                        data-input-id={input.id}
                        name={input.type === 'name' ? 'name' : input.type}
                        className="input input-bordered h-full p-3 w-full  input-sm bg-transparent border-none outline-none focus:border-none focus:outline-none"
                        placeholder={input.placeholder}
                        disabled={isEditing}
                        style={{ 
                            backgroundColor: 'transparent',
                            border: 'none',
                            boxShadow: 'none'
                        }}
                    />
                    </div>
                </div>
            ))}
           
        </div>
    );
    

   
};

export default BlockInput;